import { render } from "./GoodToGo.vue?vue&type=template&id=67683cb1"
import script from "./GoodToGo.vue?vue&type=script&lang=js"
export * from "./GoodToGo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__